import React, { useState, useEffect } from 'react';
import InventoryForm from './InventoryForm';
import { Column, Row } from 'simple-flexbox';
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from '@material-ui/core';
import useTable from '../../../utilities/useTable';
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import Controls from '../../../controls/Controls';
import { Search } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import Popup from '../../../utilities/Popup';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from '../../../utilities/Notification';
import ConfirmDialog from '../../../utilities/ConfirmDialog';
import AddInventoryForm from './AddInventoryForm';
import AddInventoryCount from './AddInventoryCount';
import InventoryCorrection from './InventoryCorrection';


const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: '75%',
  },
  newButton: {
    position: 'absolute',
    right: '10px',
  },
}));

const headCells = [
  // { id: 'contactName', label: 'Product Name' },
  { id: 'locationName', label: 'Product Name' },
  { id: 'locationAddress', label: 'Cost Price' },
  { id: 'locationName', label: 'Location Name' },
  { id: 'contactName', label: 'Quantity' },
  { id: 'contactName', label: 'Inventory Value' },
  { id: 'contactName', label: 'Retail Value' },
  { id: 'contactName', label: 'Potential Profit' },
  { id: 'contactName', label: 'Margin' },
];
function VerifyRole() {
  var role = JSON.parse(localStorage.getItem('roles'));
  if (role[0] == 'Inventory Manager' || role[0] == 'App Owner') {
    return true;
  }
}

export function InventoryValuation({
  inventory_valuation,
  LoadInventoryValuation
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(inventory_valuation, headCells, filterFn);

  useEffect(() => {
    LoadInventoryValuation();
    return () => { };
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === '') return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };


  return (
    <>
      <div
        className="container"
      
      >
        <div style={{}}>
          <Column flexGrow={1}>
            <ToastContainer />
            <div
              className="mt-5"
              style={{ position: 'relative', left: '8rem' }}
            >
              <Controls.Input
                // label="Search Inventories by Location Name"
                placeholder="Search Inventory Valuation by Location Name"
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
                watcherGetInventoryCountSaga
              />
            </div>

            <Paper className={classes.pageContent}>
              <h4>
                {' '}
                <strong>Inventory Valuation</strong>

              </h4>
              <div
                className="container row p-0 m-0"
                style={{ width: '35rem', position: 'relative', left: '23rem' }}
              >
                <div className="col">
                </div>
                <div className="col">
                  {VerifyRole() ? (
                    <Toolbar>
                      {/* <Controls.Button
                        text="Inventory Correction"
                        variant="outlined"
                        startIcon={<AddIcon />}
                        className={classes.newButton}
                        onClick={() => {
                          setCorrectionOpenPopup(true);
                          setRecordForEdit(null);
                        }}
                      /> */}
                    </Toolbar>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.locationId}>
                      {/* <TableCell>{item.productName}</TableCell> */}
                      <TableCell>{item.productName}</TableCell>
                      <TableCell>{item.costPrice}</TableCell>
                      <TableCell>{item.locationName}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{item.inventoryValue}</TableCell>
                      <TableCell>{item.retailValue}</TableCell>
                      <TableCell>{item.potentialProfit}</TableCell>
                      <TableCell>{item.margin}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>




            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    inventory_valuation: state.inventoryReducer.inventory_valuation,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadInventoryValuation(payload) {
    dispatch({ type: 'LOAD_INVENTORY_VALUATION', payload });
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryValuation);
